import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

export const Root = styled.div`
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: ${FINISH.paneBg};
`;

export const Header = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 24px 16px 16px;
`;

export const BackButton = styled.button`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 16px;
  color: ${CFG.base50};
`;

export const BackLabel = styled(Text)`
  display: inline;
`;

export const HeaderTitle = styled(Text)`
  flex: 1;
  text-align: right;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${CFG.base200};
`;

export const Body = styled.div`
  min-height: 0;
  flex: 1;
`;
